var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenEnergySmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31,0C27.3447266,0,14.8505859,0.5683594,7.5429688,7.8759766C5.4902344,9.9287109,4,13.4160156,4,16.1669922 c0,2.8249512,0.9887695,5.4945068,2.7930908,7.6258545l-6.5001221,6.5001221l1.4140625,1.4140625l6.5001221-6.5001221 C10.338501,27.0112305,13.0080566,28,15.8330078,28c2.9287109,0,6.1054688-1.3574219,8.2910156-3.5429688 C31.4316406,17.1494141,32,4.6552734,32,1C32,0.4472656,31.5527344,0,31,0z M22.7099609,23.0429688 C20.8857422,24.8671875,18.2509766,26,15.8330078,26c-2.2906494,0-4.4603882-0.7783813-6.210022-2.2089233l8.0840454-8.0840454 l-1.4140625-1.4140625l-8.0840454,8.0840454C6.7783813,20.6273804,6,18.4576416,6,16.1669922 c0-2.1982422,1.2988281-5.21875,2.9570312-6.8769531c6.2089844-6.2089844,16.6757812-7.1621094,21.0292969-7.2763672 C29.8720703,6.3671875,28.9189453,16.8339844,22.7099609,23.0429688z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEnergySmall);
export default __webpack_public_path__ + "static/media/green-energy--small.07bc61ca83b95bca69d07283471fcec0.svg";
export { ForwardRef as ReactComponent };